import { render, staticRenderFns } from "./checkDetails.vue?vue&type=template&id=2c9a6156&"
import script from "./checkDetails.vue?vue&type=script&lang=js&"
export * from "./checkDetails.vue?vue&type=script&lang=js&"
import style0 from "./checkDetails.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c9a6156')) {
      api.createRecord('2c9a6156', component.options)
    } else {
      api.reload('2c9a6156', component.options)
    }
    module.hot.accept("./checkDetails.vue?vue&type=template&id=2c9a6156&", function () {
      api.rerender('2c9a6156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/refundAudit/dialog/checkDetails.vue"
export default component.exports